import { connect } from 'react-redux';
import { parseISO } from 'date-fns';

import { selectRouteParams } from 'selectors/general';
import ScheduleFormFooter from './ScheduleFormFooter';
import { updateStartDate as updateScheduleAction } from '../../Schedules.saga';

const mapStateToProps = (state, ownProps) => {
  const { startDate: paramStartDate } = selectRouteParams(state);
  return { paramStartDate, ...ownProps };
};

const mapDispatchToProps = {
  updateStartDate: updateScheduleAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { paramStartDate, ...restStateProps } = stateProps;
  const { updateStartDate } = dispatchProps;

  return {
    updateStartDate: updateStartDate.bind(null, paramStartDate ? parseISO(paramStartDate) : new Date()),
    ...restStateProps,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ScheduleFormFooter);
